export default {
  zh: {
    ourAdvantage: 'Plex加速器 联盟推广优势',
    joinForFree: '轻松免费加入',
    freeInfo: '零成本起步，免费加入。您只需要点击注册一个账户便可开始挣钱。',
    higherConversionRate: '高转化率',
    conversionInfo: 'Plex加速器操作简单，方便使用。高转化率可以让您赚取更多的佣金。',
    sellGlobally: '全球推广',
    globallyInfo: 'Plex加速器推广不设地域限制，您可以在全球范围内推广。'
  },
  en: {
    ourAdvantage: 'Our Advantages',
    joinForFree: 'Join for Free',
    freeInfo: 'Start with zero cost and join for free. You only need to create an account, and then earn higher commission by promoting PlexVPN.',
    higherConversionRate: 'Higher Conversion Rate',
    conversionInfo: 'PlexVPN is a high speed and easy-to-use VPN application. Our high conversion rates maximize your earnings.',
    sellGlobally: 'Global Promotion',
    globallyInfo: 'We convert all geos & types of traffic (web/mobile). We offer global services, so the whole world is your customer base.'
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliateProgram/advantage/lang.js